import React, {useContext} from "react";
import DynamicContent from "../nav/DynamicContent";
import {ContentContext} from "@context/ContentContext";

const WidgetPlayer = props => {
    const {mediaId, conceptId, displayHeader = true} = props;
    const {content, dialogMediaObject} = useContext(ContentContext);
    const mediaConceptId = conceptId ? conceptId : content.currentConcept.conceptId;

    const dialogWidget = !displayHeader || dialogMediaObject != null;

    return (
        <>
            {mediaId &&
                <div className="ch-widget-player js-pw-btn-blk">
                    <DynamicContent
                        url="/lessonSection/displayWidgetEmbedded.action"
                        params={{mediaId: mediaId, conceptId: mediaConceptId, dialogWidget: dialogWidget}}
                        updateHash={false}
                    />
                </div>
            }
            {!mediaId &&
                <div className={'ch-warning-text'}>No widget to load</div>
            }
        </>
    );
};

export default WidgetPlayer;
